export default __webpack_public_path__ + "static/media/twitter_hover.d6506acc.svg";